import {  Component, Inject, OnInit, TemplateRef, ViewChild, Optional } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants, ErrorMessageFormField } from 'src/app/shared/app-constants';
import { SessionDataService } from '../../service/session-data.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConfigService } from 'src/app/services/config.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-add-edit-user-dialog',
  templateUrl: './add-edit-user-dialog.component.html',
  styleUrls: ['./add-edit-user-dialog.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatDialogModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule
  ]
})
export class AddEditUserDialogComponent implements OnInit {
  headerName: string = '';
  isEditable: boolean;
  userForm: FormGroup;
  errorMessageFormField: any =ErrorMessageFormField;
  userTypes: string[] = ['Customer', 'Administrator','US Admin'];
  userRoles: string[] = ['Read Only', 'IT', 'Admin', 'LAW-ENFORCEMENT'];
  showPassword = false;
  showConfirmPassword = false;
  sites: any = [];
  pattern: string | RegExp;
  @ViewChild('dropdown', { static: false }) dropdown: MatSelect;
  @ViewChild('dialogTemplate', { static: false })
  dialogTemplate!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) sitesPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selectedPotentialIds: any[] = [];
  searchControl = new FormControl('');
  selectedSites = new FormControl('');
  onEditSelectedSites= [];
  dataSource = new MatTableDataSource([]);
  hideSiteNames: boolean = false;
  isDialogOpen: boolean;
  searchTerm: FormControl; 
  id: any;
  header: string = 'Add Sites';
  sitesForm: FormGroup;
  searchKeyword: string = '';
  selection = new SelectionModel<any>(true, []);
  savedSelections: any[] = [];
  displayColumns: string[] = ['select', 'siteName','accountName', 'analyticId', 'potentialId'];
  pageSize:number = 8;
  sitePageSize:number = 5;
  sitePageIndex: number = 0;
  filterPageSize: number= 8;
  filterPageIndex:number = 0;
  totalSites:any;
  pageIndex:number = 0;
  totalElements = 0;
  editableData: any;
  dialogRefTemplate:MatDialogRef<any>; 
  selectedSitesDataSource = new MatTableDataSource<any>([]);
  displayedSelectedSitesColumns: string[] = ['siteName', 'potentialId','analyticId','stage','status','action'];
  assignedSites: any;
  countries: Array<{ name: string, dialCode: string }> = [
    { name: 'United States', dialCode: '+1' },
    { name: 'India', dialCode: '+91' }
  ];
  user: any;
  userId: string;
  userDetails: any;
  hideUserRole: boolean;
  hideConfirmPassword: boolean;
  totalPages: any;
  userEmail: any;
  currentUser:any;
  canShowPassword: boolean;
  canDec: boolean = false;
  decryptedPassword: string = '';
  isDecr: boolean = false;
 
  constructor( public fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<AddEditUserDialogComponent>,
    private sessionDataService: SessionDataService,
    private toaster: ToastrService,
    public spinner: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private configService: ConfigService,
    private userManagementService: UserManagementService,
    public dialog: MatDialog) {
      this.currentUser = this.authService.currentUserValue;
      this.userForm = this.fb.group({
      name: [''],
      userName: [''],
      password: [''],
      userSource:[''],
      confirmpassword:[''],
      contactVerified: [false],
      createdBy:[''],
      createdAt:[''],
      emailId: [''],
      userRole: [''],
      countryCode:['+1'],
      phoneNo : [''],
      userType : [''],
      selectedSites: [[]],
      searchControl: [''],
      mfaActive: false
    });
    this.userId =this.route.snapshot.paramMap.get('id');
    if (this.userId){
      this.prefillUserDetails();
    } else {
      this.headerName = 'Add User Details';
      this.isEditable = false;
      this.canShowPassword = true;
      this.hideSiteNames = false;
      this.hideUserRole = false;
      this.hideConfirmPassword = false;
      this.userForm = this.fb.group({
        name: [''],
        userName: [''],
        password: [''],
        userSource:[''],
        confirmpassword:[''],
        contactVerified: [false],
        createdBy:[''],
        createdAt:[''],
        emailId: [''],
        userRole: [''],
        countryCode:['+1'],
        phoneNo : [''],
        userType : [''],
        selectedSites: [[]],
        searchControl: [''],
        mfaActive: false
      });
    }
    this.searchTerm = new FormControl('');
  }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      name: [this.userForm.value.name, [Validators.required]],
      userName: [this.userForm.value.userName, [Validators.required]],
      password: [this.userForm?.value.password || '', [Validators.required,this.passwordValidator()]],
      userSource:[this.userForm?.value.userSource || ''],
      confirmpassword: [this.userForm?.value.confirmpassword || '', [Validators.required,this.passwordValidator(), this.matchPasswordValidator()]],
      contactVerified: [this.userForm?.value.contactVerified ],
      createdBy:[this.userForm?.value.createdBy || ''],
      createdAt:[this.userForm?.value.createdAt || ''],
      emailId: [this.userForm.value.emailId, [Validators.required]],
      userRole: ['Read Only'],
      countryCode: ['+1'],
      phoneNo: [this.userForm.value.phoneNo,[this.numericPhoneValidator()]],
      userType: [this.userForm.value.userType, [Validators.required]],
      selectedSites : [this.userForm.value.selectedSites],
      searchControl: [''],
      mfaActive: [this.userForm.value.mfaActive]
    });
  
    this.sitesForm = this.fb.group({
      searchKeyword: [''],
      sites: this.fb.array([])
    });
    this.sites = this.sitesForm.get('sites') as FormArray;
  
    this.userForm.get('selectedSites')?.valueChanges.subscribe((selectedSites: any) => {
      this.updateSelectedPotentialIds(selectedSites);
    });
    this.userForm.get('userType')?.valueChanges.subscribe((userType) => {
      this.onUserTypeChange(userType);
      this.updateDisplayedSelectedSitesColumns();
    });
  }
  updateDisplayedSelectedSitesColumns() {
    this.displayedSelectedSitesColumns = ['siteName', 'potentialId','analyticId','stage','status'];
    if (this.userForm.get('userType')?.value === 'Customer'  || this.userForm.get('userType')?.value === 'Sales Rep') {
      this.displayedSelectedSitesColumns.push('action');
    }
  }

  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const password = control?.value;
      if (password) {
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasDigit = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasMinLength = password.length >= 8;

        if (hasUpperCase && hasLowerCase && hasDigit && hasSpecialChar && hasMinLength) {
          return null;
        }
        return { 'passwordStrength': true };
      }
      return null;
    };
  }

numericPhoneValidator() {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value.toString().trim() === '') {
      return null;
    }
    if (!/^\d+$/.test(value)) {
      return { nonNumericPhone: true };
    }
    return null;
  };
}

  matchPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const password = this.userForm.controls['password']?.value; 
      const confirmPassword = control.value;
      if (password && confirmPassword && password !== confirmPassword) {
        return { 'passwordMismatch': true };
      }
      return null;
    };
  }


  get formControls() {
    return this.userForm.controls;
  }

updateSelectedPotentialIds(selectedSites: any[]) {
  this.selectedPotentialIds = selectedSites.map((site) => site.potentialId);
}
onUserTypeChange(userType: string) {
  if (userType != 'Customer' && userType != 'Sales Rep' && userType != '') {
    this.hideSiteNames = true;
    this.hideUserRole = true;
    this.fetchAllSites(this.sitePageIndex, this.sitePageSize);
  } else {
    this.hideSiteNames = false;
    this.hideUserRole = false;
  }
  if (this.isEditable && (userType == 'Customer')  || userType == 'Sales Rep') {
      this.selectedSitesDataSource.data = this.assignedSites;
    } else if (!this.isEditable && (userType == 'Customer')  || userType == 'Sales Rep') {
      this.selectedSitesDataSource.data = this.savedSelections;
    }
  }

  removeSelectedSite(site: any) {
    const index = this.selectedSitesDataSource.data.indexOf(site);
    if (index >= 0) {
      this.selectedSitesDataSource.data.splice(index, 1);
      this.selectedSitesDataSource._updateChangeSubscription();
      this.selection.deselect(site);
      const assignedIndex = this.assignedSites?.findIndex(
        (assignedSite) => assignedSite.potentialId === site.potentialId
      );
      if (assignedIndex >= 0) {
        this.assignedSites.splice(assignedIndex, 1);
      }
      this.selectedPotentialIds = this.selectedSitesDataSource.data.map((s) => s.potentialId);
      this.savedSelections = [...this.selectedSitesDataSource.data];
    }
  }

  prefillUserDetails() {
    this.isEditable = true;
    this.hideConfirmPassword = true;
    this.clearDecryptedPassword(); // Clear any previous decrypted password
    this.spinner.activate();
    let payload = {
      username: this.userId,
    };
    this.sessionDataService.getUserDetailsById(payload).subscribe((data: any) => {
    this.spinner.deactivate();
    this.userDetails = data;
    const matchUserType = (type: string) => {
    const match = this.userTypes.find(t => t.toLowerCase() === type?.toLowerCase());
    return match || type; 
    };
    this.userDetails.userType = matchUserType(this.userDetails.userType);
    const dialCodes = this.countries.map((c) => c.dialCode).sort((a, b) => b.length - a.length);
    const apiCountryCode = (this.userDetails.countryCode || '').toString().trim();
    let phoneValue = (this.userDetails.phoneNo || '').toString().trim();
    let countryCodeValue = apiCountryCode || '+1';

    if (apiCountryCode && phoneValue.startsWith(apiCountryCode)) {
      phoneValue = phoneValue.substring(apiCountryCode.length);
    } else {
      const matchedCode = dialCodes.find((code) => phoneValue.startsWith(code));
      if (matchedCode) {
        countryCodeValue = matchedCode;
        phoneValue = phoneValue.substring(matchedCode.length);
      }
    }
    phoneValue = phoneValue.replace(/\D/g, '');

    this.userForm.patchValue({
      ...this.userDetails,
      countryCode: countryCodeValue,
      phoneNo: phoneValue
    });
    this.userForm.controls?.confirmpassword.clearValidators();
    this.userForm.controls?.confirmpassword.updateValueAndValidity();
    if(this.isEditable) {
          this.userForm.controls?.password.clearValidators();
          this.userForm.controls?.password.updateValueAndValidity();
        }
        if(this.userDetails.userType == "Sales Rep"){
          this.userTypes.push('Sales Rep')
        }
        const role = this.currentUser?.role?.map(x => x.toLowerCase()) as Array<string>;
        const userMgmtFlag = this.configService.isFeatureEnabled('userMgmt');
        if (this.configService.isSuperAdmin()) {
          this.canShowPassword = true;
        }
        
        this.canDec = this.userManagementService.isSuperAdmin();
        this.headerName = `Edit User Details - ${this.userId}`;
        this.id = this.userDetails.id;
        if (this.userDetails.userType.toLowerCase() != 'customer' && this.userDetails.userType != 'Sales Rep') {
          this.hideSiteNames = true;
          this.hideUserRole = true;
          this.updateDisplayedSelectedSitesColumns();
          this.sitePageIndex = 0;
          this.sitePageSize = 5;
          this.fetchAllSites(this.sitePageIndex, this.sitePageSize);
        } else {
          this.updateDisplayedSelectedSitesColumns();
          this.selectedPotentialIds = this.userDetails?.potentialList?.map(
            (item) => item?.potentialId
          );
          this.assignedSites = this.userDetails.potentialList;
          this.selectedSitesDataSource.data =
            this.userDetails?.potentialList?.map((item) => ({
              siteName: item?.siteName,
              potentialId: item?.potentialId,
              analyticId: item?.analyticId,
              stage: item?.stage,
              status: item?.status
            })) || [];
          this.selectedSitesDataSource._updateChangeSubscription();
        }
      });
  }

  openSiteSelectionDialog() {
    const data = this.assignedSites?.map((item) => item?.potentialId);
    this.dialogRefTemplate = this.dialog.open(this.dialogTemplate, {
      width: '80%',
      data: {
        selectedSites: this.isEditable ? this.assignedSites : this.savedSelections
      },
      disableClose: false,
    });
    this.loadSites(this.pageSize,this.pageIndex);

    this.dialogRefTemplate.afterClosed().subscribe((data) => {
      if (data && data.length > 0) {
        if(this.isEditable) {
          this.assignedSites = data;
        }
        this.selectedSitesDataSource.data = data;
        this.selectedSitesDataSource._updateChangeSubscription();
        this.selectedPotentialIds = data.map((site) => site.potentialId);
      }
    });
  }

  closeDialog() {
    if (this.dialogRefTemplate) {
      this.dialogRefTemplate.close();
    } else if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      // If used as a route component, navigate back
      this.router.navigate(['/cp/user-management']);
    }
  }

toggleShowPassword() {
  this.showPassword = !this.showPassword;
}

toggleConfirmPassword(){
  this.showConfirmPassword = !this.showConfirmPassword;
}

  revealValue() {
    if (!this.canDec || !this.userForm.get('password')?.value) {
      return;
    }

    this.isDecr = true;    
    this.userManagementService.currentValue(this.userForm.get('password')?.value).subscribe({
      next: (response) => {
        this.decryptedPassword = response;
        this.isDecr = false;
        this.toaster.success('Done successfully');
      },
      error: (error) => {
        this.isDecr = false;
        this.toaster.error('Failed to do it');
      }
    });
  }

  clearDecryptedPassword() {
    this.decryptedPassword = '';
  }

saveSelected() {
  this.dialogRefTemplate.close(this.isEditable ? this.onEditSelectedSites : this.savedSelections);
}

  addForm() {
    const apiUrl = `${environment.workSpaceAPI}/user/save`;
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.userEmail = this.user.email;
    const requestPayload = {
      name: this.userForm.value.name,
      userName: this.userForm.value.userName,
      password: this.userForm.value.password,
      userType: this.userForm.value.userType,
      userRole: this.userForm.value.userRole,
      emailId: this.userForm.value.emailId,
      phoneNo: this.userForm.value.phoneNo.length ? `${this.userForm.value.countryCode}${this.userForm.value.phoneNo}` : '',
      countryCode: this.userForm.value.phoneNo.length ? `${this.userForm.value.countryCode}` : '',
      mfaActive: this.userForm.value.mfaActive,
      userSource: 'PV-ADMIN',
      createdBy: this.userEmail,
      potentialList: this.userForm.value.userType !== 'Customer' || !this.selectedPotentialIds?.length ? [] : this.selectedPotentialIds,
      };   
    if (this.userForm.invalid) {
      return;
    } else {
      this.spinner.activate();
      this.sessionDataService.saveUser(apiUrl, requestPayload).subscribe(
        (response) => {
          if (response && response.success) {
            this.spinner.deactivate();
            this.toaster.success('User Added Successfully..!');
            this.userForm.reset();
            this.clearDecryptedPassword();
            this.router.navigate(['/cp/user-management']);
          } else {
            this.spinner.deactivate();
            this.toaster.error(
              response?.message || AppConstants.defaultErrorMessage
            );
          }
        },
        (err) => {
          if (err) {
            this.spinner.deactivate();
            this.toaster.error(AppConstants.defaultErrorMessage);
          }
        }
      );
    }
  }

  updateForm() {
    const apiUrl = `${environment.workSpaceAPI}/user/update/` + this.id;
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.userEmail = this.user.email;
    const requestPayload = {
      name: this.userForm.value.name,
      userName: this.userForm.value.userName,
      password: this.userForm.value.password,
      userRole: this.userForm.value.userRole,
      userType: this.userForm.value.userType,
      emailId: this.userForm.value.emailId,
      phoneNo: this.userForm.value.phoneNo.length
        ? `${this.userForm.value.countryCode}${this.userForm.value.phoneNo}`
        : '',
      countryCode: this.userForm.value.phoneNo.length ? `${this.userForm.value.countryCode}` : '',
      mfaActive: this.userForm.value.mfaActive,
      contactVerified: this.userForm.value.contactVerified,
      createdBy: this.userEmail,
      potentialList:
        this.userForm.value.userType !== 'Customer' || !this.selectedPotentialIds?.length
    ? []
    : this.selectedPotentialIds
    };
    if (this.userForm.invalid) {
      return;
    } else {
      this.spinner.activate();
      this.sessionDataService.editUser(apiUrl, requestPayload).subscribe(
        (response) => {
          if (response && response.success) {
            this.spinner.deactivate();
            this.toaster.success('User Updated Successfully..!');
            this.router.navigate(['/cp/user-management']);
          } else {
            this.spinner.deactivate();
            this.toaster.error(
              response?.message || AppConstants.defaultErrorMessage
            );
          }
        },
        (err) => {
          if (err) {
            this.spinner.deactivate();
            this.toaster.error(AppConstants.defaultErrorMessage);
          }
        }
      );
    }
  }
  isSomeSelected() {
    return this.selection.selected.length > 0;
  }

  siteSelectedValue(event, site) {
    if (event.checked) {
      if (this.isEditable) {
        if (!this.onEditSelectedSites.some((s) => s.potentialId === site.potentialId)) {
          this.onEditSelectedSites.push(site);
        }
      } else {
        if (!this.savedSelections.some((s) => s.potentialId === site.potentialId)) {
          this.savedSelections.push(site);
        }
      }
    } else {
      if (this.isEditable) {
        this.onEditSelectedSites = this.onEditSelectedSites.filter((ele) => ele.potentialId !== site.potentialId);
      } else {
        this.savedSelections = this.savedSelections.filter((ele) => ele.potentialId !== site.potentialId);
      }
    }
    this.updateSelectedSitesTable();
  }

  updateSelectedSitesTable() {
    this.selectedSitesDataSource.data = this.isEditable
      ? [...this.onEditSelectedSites]
      : [...this.savedSelections];
    this.selectedSitesDataSource._updateChangeSubscription();
  }

  isSelected(site: any): boolean {
    const selectedSites = this.selectedSites.value || [];
    if (Array.isArray(selectedSites)) {
      return selectedSites.some((selectedSite: any) => selectedSite.potentialId === site.potentialId);
    }
    return false;
  }

  loadSites(pageSize: number, pageIndex: number) {
    this.spinner.activate();
    const searchKeyword = this.sitesForm.get('searchKeyword')?.value;
    let payload = {
      page: pageIndex,
      size: pageSize,
      userType: this.userForm.get('userType')?.value,
    };
    if (searchKeyword) {
      const url = `${environment.workSpaceAPI}/user/getSites?search=${searchKeyword}&page=${pageIndex}&size=${pageSize}&userType=${this.userForm.get('userType')?.value}`;
      this.sessionDataService.searchSites(url).subscribe((response: any) => {
        this.spinner.deactivate();
        this.handleSites(response.data);
      });
    } else {
      this.sessionDataService.getSiteDetails(payload).subscribe((data: any) => {
        this.spinner.deactivate();
        this.handleSites(data);
      });
    }
  }

  onSearchEnter(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    this.filterSelectedSites();
  }  
  

  filterSites() {
    this.pageIndex = 0;
    this.loadSites(this.pageSize, this.pageIndex);
  }

handleSites(data: any) {
  let dataArray: any[] = [];
  Object.keys(data.response).forEach((key) => {
    dataArray = dataArray.concat(data.response[key]);
  });
  this.dataSource.data = dataArray;
  this.totalElements = data?.totalElements;
  this.totalPages = data?.totalPages;
  this.paginator.length = this.totalElements;
  this.dataSource.sort = this.sort;
  if(this.isEditable) {
    if(!this.onEditSelectedSites || this.onEditSelectedSites.length === 0) {
     this.onEditSelectedSites = this.assignedSites ? [...this.assignedSites] : [...this.savedSelections];
    }
    this.onEditSelectedSites.forEach((site) => {
        const foundSite = this.dataSource.data.find((s) => s.potentialId === site.potentialId);
        if (foundSite) {
          this.selection.select(foundSite);
        } else {
          this.selection.select(site);
        }
     });
  } else {
      this.savedSelections.forEach((site) => {
        const foundSite = this.dataSource.data.find((s) => s.potentialId === site.potentialId);
        if (foundSite) {
          this.selection.select(foundSite);
        }
      });
    }
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      if (this.isEditable) {
        this.onEditSelectedSites = this.onEditSelectedSites.filter(
          (site) =>
            !this.dataSource.data.some(
              (row) => row.potentialId === site.potentialId
            )
        );
      } else {
        this.savedSelections = this.savedSelections.filter(
          (site) =>
            !this.dataSource.data.some(
              (row) => row.potentialId === site.potentialId
            )
        );
      }
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
      if (this.isEditable) {
        const newSelections = this.dataSource.data.filter(
          (row) =>
            !this.onEditSelectedSites.some(
              (site) => site.potentialId === row.potentialId
            )
        );
        this.onEditSelectedSites = [
          ...this.onEditSelectedSites,
          ...newSelections,
        ];
      } else {
        const newSelections = this.dataSource.data.filter(
          (row) =>
            !this.savedSelections.some(
              (site) => site.potentialId === row.potentialId
            )
        );
        this.savedSelections = [...this.savedSelections, ...newSelections];
      }
    }
    this.updateSelectedSitesTable();
  }

  isAllSelected() {
    const selectedIds = this.isEditable
      ? this.onEditSelectedSites.map((site) => site.potentialId)
      : this.savedSelections.map((site) => site.potentialId);

    return this.dataSource.data.every((row) =>
      selectedIds.includes(row.potentialId)
    );
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadSites(this.pageSize, this.pageIndex);
  }

  onSitePageChange(event: PageEvent) {
    this.sitePageSize = event.pageSize;
    this.sitePageIndex = event.pageIndex;
    this.filteredSites(this.sitePageIndex, this.sitePageSize);
  }

  clearSearch(): void {
    this.sitesForm.get('searchKeyword')?.setValue('');
    this.pageIndex = 0;
    this.pageSize = 8;
    this.loadSites(this.pageSize, this.pageIndex);
  }

  clearSelectedSiteSearch() {
    this.searchTerm.setValue('');
    this.sitePageIndex = 0;
    this.sitePageSize = 5;
    this.fetchAllSites(this.sitePageIndex, this.sitePageSize);
  }

  fetchAllSites(sitePageIndex, sitePageSize) {
    const payload = {
      page: sitePageIndex,
      size: sitePageSize,
      userType: this.userForm.get('userType')?.value
    };
    this.sessionDataService.getSiteDetails(payload).subscribe((data: any) => {
      this.spinner.deactivate();
      let dataArray: any[] = [];
      const responseBody = data?.response || data || {};
      if (Array.isArray(responseBody)) {
        dataArray = responseBody;
      } else {
        Object.keys(responseBody).forEach((key) => {
          if (Array.isArray(responseBody[key])) {
            dataArray = dataArray.concat(responseBody[key]);
          }
        });
      }
      this.selectedSitesDataSource.data = dataArray.map((item) => ({
        siteName: item?.siteName,
        potentialId: item?.potentialId,
        analyticId: item?.analyticId,
        stage: item?.stage,
        status: item?.status,
        accountName: item?.accountName
      }));
      this.totalSites = data?.totalElements ?? dataArray.length;
      if (this.sitesPaginator) {
        this.sitesPaginator.length = this.totalSites;
      }
    });
  }

  filterSelectedSites() {
    this.sitePageIndex = 0;
    this.sitePageSize = 5;
    this.filteredSites(this.sitePageIndex, this.sitePageSize);
  }

  filteredSites(sitePageIndex, sitePageSize) {
    this.spinner.activate();
    const searchValue = this.searchTerm.value;
    if (searchValue) {
      const url = `${environment.workSpaceAPI}/user/getSites?search=${searchValue}&page=${sitePageIndex}&size=${sitePageSize}&userType=${this.userForm.get('userType')?.value}`;
      this.sessionDataService.searchSites(url).subscribe((response: any) => {
        this.spinner.deactivate();
        let dataArray: any[] = [];
        const responseBody = response?.data?.response || response?.data || response?.response || {};
        if (Array.isArray(responseBody)) {
          dataArray = responseBody;
        } else {
          Object.keys(responseBody).forEach((key) => {
            if (Array.isArray(responseBody[key])) {
              dataArray = dataArray.concat(responseBody[key]);
            }
          });
        }
        this.selectedSitesDataSource.data = dataArray.map((item) => ({
          siteName: item?.siteName,
          potentialId: item?.potentialId,
          analyticId: item?.analyticId,
          stage: item?.stage,
          status: item?.status,
          accountName: item?.accountName
        }));
        this.totalSites = response?.data?.totalElements ?? response?.totalElements ?? dataArray.length;
        if (this.sitesPaginator) {
          this.sitesPaginator.length = this.totalSites;
        }
      });
    } else {
      this.fetchAllSites(sitePageIndex, sitePageSize);
    }
  }
}
 
  